import { API_URL } from '../../../../modules/auth/core/_requests';
import { LineItemUpdate, BulkUpdatePayload } from '../utils/lineItemTransforms';

export interface BulkUpdateResponse {
  success: boolean;
  data?: {
    updated_count: number;
    failed_updates?: Array<{
      line_item_id: string;
      error: string;
    }>;
  };
  error?: string;
  details?: string;
}

export const updateLineItemsBulk = async (orderId: string, lineItemUpdates: LineItemUpdate[]): Promise<BulkUpdateResponse> => {
  const payload: BulkUpdatePayload = {
    order_id: orderId,
    line_item_updates: lineItemUpdates
  };

  const response = await fetch(`${API_URL}/api/shopify-shipping/dashboard/admin-control/line-items`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  });

  const data: BulkUpdateResponse = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Failed to update line items');
  }

  return data;
}; 